import React from 'react';
import { useHistory } from 'react-router-dom';
import { PendDocsHeader, PendDocsBody, PendDocsTitle } from './styled';
import imgWarning from '../../../assets/illustrations/warning.svg';
import iconWsp from '../../../assets/icons/IconWhatsapp.svg';
import routes from '../../components/Routes/routingMap';
import Link from '@/presentation/reusables/Link';
import ContentModalTwoButtons from '@/presentation/modules/procedures/components/ContentModalTwoButtons';

interface IProps {
  handlerClose: () => void;
}

const ModalPendDocsView = ({ handlerClose }: IProps) => {
  const history = useHistory();
  const paramSendDocs = 'TA0037';
  const toSendDocs = () => {
    handlerClose();
    setTimeout(() => {
      history.push(
        `${routes.student.procedures.categories.tickets.register}?v=${paramSendDocs}`
      );
    }, 100);
  };

  const renderTitle = () => (
    <PendDocsHeader>
      <PendDocsTitle>
        <b>¡Hola! Todavía no hemos recibido tus documentos.</b>
      </PendDocsTitle>
    </PendDocsHeader>
  );

  const renderSubTitle = () => (
    <PendDocsHeader>
      <PendDocsTitle>
        <span>
          Envíalos a través de solicitudes SAE cuando los tengas listos. Fecha
          límite: 18 de julio. Si ya enviaste tus documentos, omite este
          mensaje.
        </span>
      </PendDocsTitle>
      <PendDocsBody>
        <img src={iconWsp} alt="whatsapp" />
        <span>
          Para resolver tus dudas escríbenos al:{' '}
          <Link
            linkType="external"
            url={`https://api.whatsapp.com/send?phone=51960252970`}
            linkName="960 252 970"
          />
        </span>
      </PendDocsBody>
    </PendDocsHeader>
  );
  return (
    <ContentModalTwoButtons
      img={imgWarning}
      title={renderTitle()}
      subtitle={renderSubTitle()}
      showInfo={false}
      textButton1="Enviar documentos"
      textButton2="Omitir"
      onClickButton1={toSendDocs}
      onClickButton2={handlerClose}
    />
  );
};

export { ModalPendDocsView };
